import styled from 'styled-components';

export const StickyWrapper = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 800;
  background: #ffffff;
  border-top: 1px solid #D8DADA;
  padding: 24px 0 14px;

  @media (max-width: 767px) {
    position: static;
    padding: 10px 16px 0;
  }
`;

export const MobileFixedWrapper = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 800;
    background: #ffffff;
    border-top: 1px solid #D8DADA;
    padding: 10px 16px 0;
  }
`;

export const MobileSpacer = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: block;
    height: ${({ height }) => `${height}px`};
  }
`;

export const DesktopContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1272px;
  margin: 0 auto;
  padding: 0 18% 0 20px;
  box-sizing: border-box;
  gap: 4px;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const GroupWrapper = styled.div`
  flex: 1;
`;

export const GroupLabel = styled.div`
  background: none;
  border: 0;
  font-family: 'Verizon-NHG-eTX';
  font-size: 12px;
  font-weight: 400;
  color: ${({ isActive }) => (isActive ? '#EE001E' : '#716F6D')};
  margin-bottom: 6px;
  min-height: 18px;
  padding: 0;
  text-align: left;
  line-height: 16px;
  white-space: nowrap;
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
`;

export const GroupBars = styled.div`
  display: flex;
  gap: 2px;
`;

export const BarSegment = styled.div`
  flex: 1;
  height: 4px;
  border-top-left-radius: ${({ isFirstInGroup }) => (isFirstInGroup ? '20px' : '0')};
  border-bottom-left-radius: ${({ isFirstInGroup }) => (isFirstInGroup ? '20px' : '0')};
  border-top-right-radius: ${({ isLastInGroup }) => (isLastInGroup ? '20px' : '0')};
  border-bottom-right-radius: ${({ isLastInGroup }) => (isLastInGroup ? '20px' : '0')};
  background: ${({ isCompleted }) => (isCompleted ? '#EE001E' : '#D8DADA')};
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
  pointer-events: ${({ isFuture }) => (isFuture ? 'none' : 'auto')};
  transition: background 0.3s ease;
`;

/* ── Mobile ──────────────────────────────────────────────────────────── */

export const MobileOnly = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export const MobileLabels = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
`;

export const MobileLabel = styled.div`
  background: none;
  border: 0;
  font-family: 'Verizon-NHG-eTX';
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: ${({ isActive }) => (isActive ? '#EE001E' : '#716F6D')};
  padding: 0;
  text-align: left;
  white-space: nowrap;
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
`;

export const MobileGroupedBars = styled.div`
  display: flex;
  width: 100%;
  gap: 4px;
`;
